<template>
    <div class="hotBox" id="HotBox">
        <div class="titleBox clearfix">
          <div class="left fl">
            48小时热帖
          </div>
          <a class="change fr" href="javascript:void(0);" @click="change">换一换</a>
        </div>
        <ul class="list_box">
            <li class="list clearfix" :class="item.no=='01'?'active':item.no=='02'?'active1':item.no=='03'?'active2':''" v-for="(item,i) in currentPageData" :key="i">
              <router-link :to="{path:`/newsdetail/${item.tid}`}" target="_blank">
                 <div  class="right nowrap">
                    {{item.subject}}
                 </div>
              </router-link>
            </li>
        </ul>
    </div>
</template>
<script>

import service from '@/api/service/service'
export default {
    props:['streetId','hotlist','sid'],
    data() {
        return {
          page:1,
          hotthreadList:[],
          currentPageData:[],
          currentPage:1,
          totalPage:1,
          pageSize:10,
          isshow:true,
          noChange:true,
        }
    },
    mounted() {
      this.totalPage = Math.ceil(this.hotlist.length / this.pageSize);
      this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
      this.currentPageData = this.hotlist.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    methods:{
      // 换一换
      change() {
        if (this.currentPage == this.totalPage) {
          this.currentPage = 0
          this.pageSize = 10
          this.currentPageData = this.hotlist.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        };
        
        this.currentPage++;
        let begin = (this.currentPage -1) *this.pageSize;
        let end = this.currentPage *this.pageSize
        this.currentPageData = this.hotlist.slice(begin,end);
      }
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
    #HotBox{
        margin:15px 0 0;
        height:412px;
        padding-top:12px;
        border-radius:5px;
        background: #f8f8f8;
        .titleBox{
          line-height: 22px;
          margin:0 0 6px 0;
          .left{
            padding:0 0 0 15px;
            color:@c3;
            font-size:@ft20;
            position: relative;
            &::before{
              width: 5px;
              height: 20px;
              display: inline-block;
              content:'';
              top:2px;
              left:0;
              background: #d51938;
              position: absolute;
            }
          }
          .change{
            color:@hred;
            font-size:@ft16;
            padding:0 15px 0 21px;
            background: url('~@/assets/imgs/hh.png') no-repeat left center;
            background-size:16px;
          }
        }
        .list_box{
            .list{
                cursor: pointer;
                position: relative;
                line-height: 36px;
                a:visited{
                  color:#d51938;
                }
                &.active{
                  &::before{
                    background:#fe9e9e;
                  }
                }
                &.active1{
                  &::before{
                    background:#f7a77e;
                  }
                }
                &.active2{
                  &::before{
                    background:#8ecffc;
                  }
                }
                &::before{
                  position: absolute;
                  content: '';
                  display: block;
                  width:6px;
                  height: 6px;
                  background:#8ecffc;
                  left:15px;
                  top:50%;
                  margin-top:-3px;
                  border-radius: 50%;
                }
                .right{
                  padding:0 15px 0 36px;
                  color:@c3;
                  font-size:@ft16;
                  overflow: hidden;
                  // margin:20px 0 0;
                  display: block;
                  &:hover{
                    color:#2d8ed9;
                  }
                }
                &:last-child {
                    border-bottom:0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/hot.vue